<div class="assigned-role-dialog-container mat-typography">
  <div class="dialog-header">
    <span
      class="role-icon"
      [ngClass]="data.roleDetails.roleGroupIconColor">
      <mat-icon [svgIcon]="data.roleDetails.roleGroupIconImage"></mat-icon>
    </span>
    <h2 class="title">
      {{ data.roleDetails.requestedRole }}
    </h2>
  </div>

  <mat-dialog-content>
    <ul data-cy="role-descriptions-list">
      <li *ngFor="let bulletPoint of data.role.descriptions">
        {{ bulletPoint }}
      </li>
    </ul>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      class="close-button"
      mat-flat-button
      color="primary"
      (click)="onAssignedRoleDialogClose()">
      Close
    </button>
  </mat-dialog-actions>
</div>
